import { createSelector } from '@ngrx/store';
import { FlowTypes } from '@shared/models';
import { ConfirmContent } from '@shared/services/content/content-jsons/confirm-content';

import { selectTriageState } from '../triage/triage.selectors';
import { selectGiftingReceiptData } from './gifting/gifting-receipt.selectors';
import { selectInheritanceReceiptData } from './inheritance/inheritance-receipt.selectors';
import { selectInheritedIraReceiptData } from './inherited-ira/inherited-ira-receipt.selectors';
import { selectMinorReceiptData } from './minor-transfer/minor-transfer-receipt.selectors';

export const selectReceiptData = createSelector(
  selectTriageState,
  selectInheritanceReceiptData(),
  selectMinorReceiptData(),
  selectGiftingReceiptData(true),
  selectInheritedIraReceiptData(true, ConfirmContent.receiptContent),
  (triage, inheritance, minor, gifting, inheritedIra) => {
    switch (triage.flowType) {
      case FlowTypes.INHERITANCE:
        return inheritance;
      case FlowTypes.MINOR:
        return minor;
      case FlowTypes.GIFTING:
        return gifting;
      case FlowTypes.INHERITED_IRA:
        return inheritedIra;
    }
  },
);
